import { globalStores } from '.';
import { IWallEdge } from '../types';

export class EdgeStore {
  private wallEdges: IWallEdge[] = [];
  private sepEdgeMap: Map<string, IWallEdge[]> = new Map();

  constructor() {
    this.wallEdges = [];
    this.sepEdgeMap = new Map();
  }

  // ============================= 墙体边操作 =============================
  getWallEdges() {
    return this.wallEdges;
  }

  addWallEdge(edge: IWallEdge) {
    this.wallEdges.push(edge);
  }

  updateWallEdges(edges: IWallEdge[]) {
    this.wallEdges = edges;
  }

  clearWallEdges() {
    this.wallEdges = [];
  }

  // ============================= 隔墙边操作 =============================
  getSepEdges(roomId: string) {
    return this.sepEdgeMap.get(roomId) || [];
  }

  clearSepEdges(roomId: string) {
    this.sepEdgeMap.delete(roomId);
  }

  updateSepEdges(roomId: string, edges: IWallEdge[]) {
    this.sepEdgeMap.set(roomId, edges);
  }

  // 删除不存在的房间数据
  refreshSepEdges() {
    const roomSet = new Set(globalStores.roomStore.getRoomDatas().map((roomData) => roomData.id));
    this.sepEdgeMap.forEach((_, roomId) => {
      if (!roomSet.has(roomId)) {
        this.clearSepEdges(roomId);
      }
    });
  }

  // ============================= 方案保存相关 =============================
  clearAll() {
    this.clearWallEdges();

    this.sepEdgeMap.clear();
  }
}

export default EdgeStore;
